import { useCallback, useEffect, useState } from 'react';
import { useAdminAuth } from '../pages/admin/RequireAdminAuth';
import { useToast } from '../context/ToastContext';
import './impersonationBanner.css';

/**
 * ImpersonationBanner
 * 
 * Kullanıcı impersonation modundayken en üstte gösterilen banner.
 * Admin'in hangi kullanıcı olarak giriş yaptığını gösterir ve çıkış butonu sunar.
 */
function ImpersonationBanner() {
    const { session } = useAdminAuth();
    const { showSuccess, showError } = useToast();
    const [impersonationInfo, setImpersonationInfo] = useState(null);
    const [ending, setEnding] = useState(false);

    // Impersonation durumunu kontrol et
    useEffect(() => {
        const checkImpersonation = async () => {
            try {
                const response = await fetch('/api/impersonation/status');
                const data = await response.json();
                if (data.status === 'success' && data.isImpersonation) {
                    setImpersonationInfo(data);
                } else {
                    setImpersonationInfo(null);
                }
            } catch (err) {
                console.error('Check impersonation status error:', err);
            }
        };

        checkImpersonation();
    }, [session]);

    // localStorage'dan da kontrol et
    useEffect(() => {
        const originalAdmin = localStorage.getItem('original_admin');
        const sessionToken = localStorage.getItem('impersonation_session');

        if (originalAdmin && sessionToken) {
            try {
                const admin = JSON.parse(originalAdmin);
                setImpersonationInfo({
                    isImpersonation: true,
                    admin,
                    sessionToken,
                    targetUser: session
                });
            } catch (e) {
                // ignore
            }
        }
    }, [session]);

    // Impersonation'ı sonlandır
    const handleEndImpersonation = useCallback(async () => {
        setEnding(true);
        try {
            const sessionToken = localStorage.getItem('impersonation_session');

            const response = await fetch('/api/impersonation/end', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ sessionToken })
            });

            const data = await response.json();

            // localStorage temizle
            localStorage.removeItem('impersonation_token');
            localStorage.removeItem('impersonation_session');
            localStorage.removeItem('original_admin');

            if (data.status === 'success') {
                showSuccess('Impersonation sonlandırıldı. Admin hesabınıza dönüyorsunuz...');

                // Sayfayı yenile - normal login sayfasına yönlendir
                setTimeout(() => {
                    window.location.href = '/login';
                }, 1000);
            } else {
                // Yine de logout yap
                window.location.href = '/login';
            }
        } catch (err) {
            console.error('End impersonation error:', err);
            showError('Çıkış yapılırken hata oluştu');
            // Yine de temizle ve çık
            localStorage.removeItem('impersonation_token');
            localStorage.removeItem('impersonation_session');
            localStorage.removeItem('original_admin');
            window.location.href = '/login';
        } finally {
            setEnding(false);
        }
    }, [showSuccess, showError]);

    // Impersonation yoksa render etme
    if (!impersonationInfo?.isImpersonation) {
        return null;
    }

    return (
        <div className="impersonation-banner">
            <div className="banner-content">
                <div className="banner-icon">
                    <i className="fas fa-user-secret"></i>
                </div>
                <div className="banner-text">
                    <strong>{impersonationInfo.admin?.username}</strong> olarak
                    <span className="target-user"> {session?.username || impersonationInfo.targetUser?.username}</span>
                    &nbsp;kullanıcısının hesabındasınız
                </div>
                <button
                    className="end-btn"
                    onClick={handleEndImpersonation}
                    disabled={ending}
                >
                    {ending ? (
                        <><i className="fas fa-spinner fa-spin"></i> Çıkılıyor...</>
                    ) : (
                        <><i className="fas fa-sign-out-alt"></i> Çıkış Yap</>
                    )}
                </button>
            </div>
        </div>
    );
}

export default ImpersonationBanner;
